export const isLandViewPathActive = (pathname, landId) => {
  if (!pathname || !landId) {
    return false
  }

  return pathname.includes(`/land/view/${encodeURIComponent(landId)}`)
}

export const resolveLandSnapshot = ({
  currentLand,
  targetLandId,
  field,
  lands,
}) => {
  if (!targetLandId) {
    return null
  }

  if (currentLand?.land_id === targetLandId) {
    return currentLand
  }

  const listedLand = Array.isArray(lands)
    ? lands.find((candidate) => candidate?.land_id === targetLandId)
    : null

  if (!listedLand) {
    return null
  }

  return {
    ...listedLand,
    field: listedLand.field || field || null,
    field_id: listedLand.field_id || field?.field_id || null,
  }
}
